import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "header" }
const _hoisted_2 = { id: "navigation" }
const _hoisted_3 = {
  id: "secondary-menu",
  class: "wrapper clearfix"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "logo-image" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/placeholders/logo.gif",
      alt: "logo"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/placeholders/logo1.gif",
      alt: "logo"
    })
  ])
], -1)
const _hoisted_5 = {
  class: "clearfix",
  id: "main-nav"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  href: "/list?categoryId=2",
  target: "_blank"
}, "国藏产品", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", {
  href: "/list?categoryId=3",
  target: "_blank"
}, "国藏新闻", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<li><a href=\"#\">国藏运营</a><ul><li><a href=\"https://i.snssdk.com/rogue/ugc/profile/?version_code=7.3.6&amp;version_name=70306&amp;user_id=52689479666&amp;media_id=1588566535703565&amp;request_source=1&amp;active_tab=dongtai&amp;device_id=65&amp;app_name=news_article&amp;tt_from=weixin&amp;utm_source=weixin&amp;utm_medium=toutiao_ios&amp;utm_campaign=client_share&amp;wxshare_count=1\" target=\"_black\">头条资讯</a></li><li><a href=\"https://author.baidu.com/home/1590102565784506\" target=\"_black\">百度资讯</a></li><li><a href=\"https://weibo.com/guocangtianxia?sudaref=www.baidu.com&amp;display=0&amp;retcode=6102&amp;is_hot=1\" target=\"_black\">新浪微博</a></li><li><a href=\"https://haohuo.jinritemai.com/views/shop/index?id=UridjQs&amp;origin_type=604&amp;origin_id=0&amp;new_source_type=47&amp;new_source_id=0&amp;source_type=47&amp;source_id=0&amp;come_from=0\" target=\"_black\">头条商城</a></li><li><a href=\"https://author.baidu.com/home/1590102565784506\" target=\"_black\">百度商城</a></li></ul></li><li><a href=\"#\">关于国藏</a><ul><li><a href=\"/info?id=2\" target=\"_blank\">关于我们</a></li><li><a href=\"/info?id=3\" target=\"_blank\">招贤纳士</a></li><li><a href=\"/info?id=4\" target=\"_blank\">联系我们</a></li></ul></li>", 2)
const _hoisted_14 = { id: "header-bottom" }
const _hoisted_15 = { class: "wrapper clearfix" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div id=\"headline\" class=\"clearfix\"><div class=\"horizontal_scroller\"><ul class=\"scrollingtext clearfix\"><li>2022-01-11<a href=\"http://ciqi.guocangvip.com/article-670.html\" target=\"_blank\">青花瓷千年窑火中的精品|国藏文化艺术品收藏平台</a></li><li>2022-01-13<a href=\"#\" target=\"_blank\">特许商品“景泰蓝和田玉冰壶”在北京会议中心发布 非遗文创精品“喜迎冬奥”</a></li></ul></div></div>", 1)
const _hoisted_17 = {
  id: "search-social",
  class: "clearfix"
}
const _hoisted_18 = { class: "search-box clearfix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", {
            class: _normalizeClass({ 'current-menu-item': this.categoryId == 0 })
          }, _hoisted_7, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ 'current-menu-item': this.categoryId == 2 })
          }, _hoisted_9, 2),
          _createElementVNode("li", {
            class: _normalizeClass({ 'current-menu-item': this.categoryId == 3 })
          }, _hoisted_11, 2),
          _hoisted_12
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _withDirectives(_createElementVNode("input", {
                onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.btnFind(_ctx.keywords)), ["enter"])),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keywords) = $event)),
                class: "search-text"
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.keywords,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("input", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.btnFind(_ctx.keywords))),
                type: "button",
                class: "search-submit"
              })
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}